import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
export function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') {
            return
            getToken = ''
        }else if(getToken.Authorization && getToken.Authorization.includes('undefined')){
            return
        }
        credentials.localParams.parameter.pageLoader = true
        let link = (credentials.localParams.link)?apiLink:Enpoints.BASE_URL + apiLink
        if(credentials.localParams.link){
            RxFactory.get(link, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                        // console.log('api-data',data,'url',apiLink)
                        // if(Object.keys(data).length == 0){
                        //     callback(false, {"info":"NOK","msg":{"code":"TECH_ERROR","msg":"Some Technical issue"},"data":{},"errors":error})
                        // }
                        // console.log(link, "data should be here", data)
                        credentials.localParams.parameter.pageLoader = false
                        if ('info' in data) {
                            if (data.info === 'OK') {
                                response_array.res_data = data.data
                                callback(false, response_array)
                            } else {
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                } else {
                                    response_array.res_data = data.msg
                                }
                                callback(true, response_array)
                            }
                        }
                    },
                    e => { _handleErrorResponse(e, commit) })
        }else{
            RxFactory.post(link, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                        // console.log('api-data',data,'url',apiLink)
                        // if(Object.keys(data).length == 0){
                        //     callback(false, {"info":"NOK","msg":{"code":"TECH_ERROR","msg":"Some Technical issue"},"data":{},"errors":error})
                        // }
                        credentials.localParams.parameter.pageLoader = false
                        if ('info' in data) {
                            if (data.info === 'OK') {
                                response_array.res_data = data.data
                                callback(false, response_array)
                            } else {
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                } else {
                                    response_array.res_data = data.msg
                                }
                                callback(true, response_array)
                            }
                        }
                    },
                    e => { _handleErrorResponse(e, commit) })
        }
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
export function _executePostApi(apiLink, credentials, getToken, commit, type = 'Post', callback ) {
    try {
        let response_array = []
        if (getToken == '') {
            return
            getToken = '' 
        }else if(getToken.Authorization && getToken.Authorization.includes('undefined')){
            return
        }
        credentials.localParams.parameter.pageLoader = true;
        RxFactory[type](apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                credentials.localParams.parameter.pageLoader = false
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        callback(false, response_array)
                    } else {
                        if (typeof data.msg == 'object') {
                            response_array.res_data = data.msg.msg
                        } else {
                            response_array.res_data = data.msg
                        }
                        callback(true, response_array)
                    }
                }
            },
            e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
export function _executeGetApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = [];
        credentials.localParams.parameter.pageLoader = true
        RxFactory.get(apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                credentials.localParams.parameter.pageLoader = false
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        callback(false, response_array)
                    } else {
                        if (typeof data.msg == 'object') {
                            response_array.res_data = data.msg.msg
                        } else {
                            response_array.res_data = data.msg
                        }
                        callback(true, response_array)
                    }
                }
            },e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

export function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

export function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

export function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

export function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}

export function _setDrawingToolLocalStorage(drawingsData){
    if(!!drawingsData && drawingsData.drawingIsins && drawingsData.drawingIsins.length > 0){
    let drawingIsins = drawingsData.drawingIsins || []
    let _drawings = drawingsData._drawings || {}
    if(typeof _drawings === 'object' && Object.keys(_drawings).length > 0){
        localStorage.setItem('_drawings', JSON.stringify(_drawings))
    }
    if(Array.isArray(drawingIsins) && drawingIsins.length > 0){
        localStorage.setItem('previousDrawings',JSON.stringify([...drawingIsins]))
        drawingIsins.forEach((isin)=>{
            let currentIsinKey = Object.keys(isin)
            currentIsinKey = currentIsinKey.length > 0 ? currentIsinKey[0] : null
            const currentIsinValue = !currentIsinKey ? [] : isin[currentIsinKey]
            if(Array.isArray(currentIsinValue) && currentIsinValue.length > 0 && !!currentIsinKey){
                localStorage.setItem(currentIsinKey, JSON.stringify(currentIsinValue))
            }
        })
    }
    }
}


// WEBPACK FOOTER //
// ./src/store/commomFunction.js